import { useCallback, useEffect, useMemo, useState } from 'react';
import { Table, TableHead, TableRow, TableCell, TableBody, Checkbox, Pagination, TableSortLabel } from '@mui/material';
import { NoData } from '../components/NoData';
import _ from 'lodash';
import IconButton from '@mui/material/IconButton';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { colors } from '../styles/colors';
import PdfTable from '../utils/pdfTable';
import InfoIcon from '@mui/icons-material/Info';
import PropTypes from 'prop-types';
import React from 'react';
import { componentFormatters } from 'utils/formatters';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

// Стили для таблицы
export const styleTable = {
    cell: {
        fontFamily: 'primary',
        fontSize: 14,
        color: 'black',
    },
    place: {
        width: '100%',
        backgroundColor: 'white',
        borderRadius: '7px'
    },
    headerCell: {
        fontFamily: 'primary',
        fontSize: 14,
        color: 'black'
    }
};

// функция вызова форматтера
// передаём значение, дескриптор, id и функция для изменения если нужна (для редак данных)
export const renderFormatted = (value, field, id, onFormatterChange, onClickRow) => {
    if (field.formatter) {
        const Formatter = componentFormatters[field.formatter];
        // console.log("FORMATTERVALUE", value)
        if (Formatter) return (
            <div onClick={(e) => e.stopPropagation()} style={{width: "100%"}}>
                <Formatter value={value} desc={field} id={id} onChange={onFormatterChange} onClickRow={onClickRow}/>
            </div>
        );
    }
    return value;
};

/**
* ds - descriptor
* data - данные (массив)
* onSelect - Callback при изменении выбранных строк.
* count - Общее количество записей для пагинации.
* onPageChange - Callback при изменении страницы.
* onClickRow - Callback при клике на строку.
* onFormatterChange - Callback при изменении в форматтере данных
 */
export function ReportTable({ ds, data, onSelect, count, onPageChange, onClickRow, filterSettings, onFormatterChange, autoPagination, inputSelected, aditionalAction, editable, finded, customNoDataText}) {
    const $fields = useMemo(() => [...ds.descr.items].filter((el) => el.table !== false), [ds]);
    const [selected, setSelected] = useState([]);  
    const [selectedRowId, setSelectedRowId] = useState(null); 
    const [expandedRows, setExpandedRows] = useState([]); 
    const [showData, setShowData] = useState([]);  
    const [currentPage, setCurrentPage] = useState(1);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    console.log("ds.descr.additionalOrientation", ds.descr.additionalOrientation)

    // Вся логика фильтрации и сортировки ТУТ
    const processedData = useMemo(() => {
        if (!data || !Array.isArray(data)) return [];
        let result = [...data];

        console.log('result0', result)

        if (filterSettings?.active && filterSettings?.filter) {
            const searchTerm = String(filterSettings.filter).toLowerCase();
            
            result = result.filter((row) => {
                // Ищем совпадение хотя бы в одном из выбранных полей (checkList)
                return filterSettings.checkList.some((path) => {
                    const value = _.get(row, path);
                    if (value === null || value === undefined) return false;
                    return String(value).toLowerCase().includes(searchTerm);
                });
            });
        }

        console.log('result1', result)

        console.log('TABLE DATA', data)

        if (sortConfig.key) {
            const dir = sortConfig.direction === 'desc' ? 'desc' : 'asc';
            result = _.orderBy(result, [(row) => {
                let val = null;
                // Используем те же пути, что и в дескрипторе
                switch (sortConfig.key) {
                    case 'data': val = _.get(row, 'data.title'); break;
                    case 'size': val = _.get(row, 'data.totalCount'); break;
                    case 'sizes': val = _.get(row, 'data.vendorCode'); break;
                    case 'countOnSizes': val = _.get(row, 'countOnSizes.total'); break;
                    case 'inRoadOnSizes': val = _.get(row, 'inRoadOnSizes.total'); break;
                    case 'storageOnSize': val = _.get(row, 'storageOnSize.total'); break;
                    default: val = _.get(row, sortConfig.key);
                }
                
                if (typeof val === 'string') return val.toLowerCase();
                if (!isNaN(parseFloat(val)) && isFinite(val)) return Number(val);
                return val;
            }], [dir]);
        }
        console.log('result2', result)

        return result;
    }, [data, sortConfig, filterSettings]);

    const isSingleSelect = ds?.descr?.singleSelect === true;

    const handleSort = (fieldId) => {
        setSortConfig((prev) => {
            if (prev.key === fieldId) {
                return {
                    key: fieldId,
                    direction: prev.direction === 'asc' ? 'desc' : 'asc'
                };
            }
            return {
                key: fieldId,
                direction: 'asc'
            };
        });
    };

    const onAutoPageChange = useCallback((page) => {
        setCurrentPage(page); 
        if (autoPagination > 0) {
            const start = (page - 1) * autoPagination;
            setShowData(processedData.slice(start, start + autoPagination));
        } else {
            setShowData(processedData);
        }
    }, [processedData, autoPagination]);

    useEffect(() => {
        if (autoPagination > 0) {
            const maxPages = Math.max(1, Math.ceil(processedData.length / autoPagination));
            const targetPage = currentPage > maxPages ? maxPages : (currentPage || 1);
            onAutoPageChange(targetPage);
        } else {
            setShowData(processedData);
        }
    }, [processedData, autoPagination, currentPage, onAutoPageChange]);

    useEffect(() => {
        setSelected(inputSelected);
    }, [inputSelected]);

    const toggleRow = useCallback((id) => {
        console.log("toggleRow")
        setExpandedRows((prev) =>
            prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
        );
    }, [setExpandedRows]);

    const handleClick = useCallback((id) => {
        let newSelected = [];
        if (isSingleSelect) {
            newSelected = [id];
        } else {
            const selectIndex = selected.findIndex((el) => el === id);
            if (selectIndex === -1) {
                newSelected = [...selected, id];
            } else {
                newSelected = selected.filter(el => el !== id);
            }
        }
        setSelected(newSelected);
        if (onSelect) onSelect(newSelected);
    }, [selected, setSelected, onSelect, isSingleSelect]);

    const formatterChangeSelecter = (data) => {
        if (selected.findIndex((el) => el === data.row.id) === -1) {handleClick(data.row.id)}
        onFormatterChange(data)
    }

    const handleSelectAllClick = useCallback((event) => {
        if (isSingleSelect) return;
        if (event.target.checked) {
            const newSelected = processedData.map((n) => n.id);
            if (onSelect) onSelect(newSelected);
            setSelected(newSelected);
            return;
        }
        if (onSelect) onSelect([]);
        setSelected([]);
    }, [setSelected, onSelect, processedData, isSingleSelect]);
    
    const CHECKBOX_COLUMN_WIDTH = "30px"

    if (data && showData && data.length > 0 && showData.length === 0) return <NoData text={"Рендерим данные"}/>;
    if (!data || (!Array.isArray(showData)) || showData?.length <= 0) return <NoData text={customNoDataText}/>;
    return (
        <div style={{backgroundColor: 'white', width: 'max-content', minWidth: '100%'}}>
            {ds.descr.pdf === true && (
                <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                    <IconButton aria-label="pdf" onClick={() => PdfTable(ds, data)}>
                        <PictureAsPdfIcon sx={{ color: colors.elements }} />
                    </IconButton>
                </div>
            )}
            
            <Table stickyHeader style={{ ...styleTable.place }}>
                {!ds.descr.noHeader &&
                <TableHead>
                    <TableRow>
                        {ds.descr.showCheckboxes && (
                            <TableCell 
                                align='center' 
                                key="allCheck"
                                sx={{ 
                                    width: CHECKBOX_COLUMN_WIDTH,
                                    minWidth: CHECKBOX_COLUMN_WIDTH,
                                    maxWidth: CHECKBOX_COLUMN_WIDTH,
                                    padding: 0,               // убираем внутренние отступы
                                    textAlign: 'center'
                                }}
                            >
                                {!isSingleSelect && (
                                    <Checkbox
                                        disabled={!editable}
                                        checked={selected.length === processedData.length && processedData.length > 0}
                                        onClick={handleSelectAllClick}
                                    />
                                )}
                            </TableCell>
                        )}

                        {$fields.map((el) => {
                            const isCurrentActive = sortConfig.key === el.id;
                            const currentDir = sortConfig.direction === 'desc' ? 'desc' : 'asc';

                            // ДОБАВЛЕНО: стили для закрепления шапки с учетом left и right
                            const stickyStyle = el.visible ? {
                                position: 'sticky',
                                ...(el.visible === 'left' ? { left: 0, boxShadow: '2px 0 5px rgba(0,0,0,0.15)' } : { right: 0, boxShadow: '-2px 0 5px rgba(0,0,0,0.15)' }),
                                backgroundColor: 'white',
                                zIndex: 10,
                            } : {};

                            return (
                                <TableCell
                                    key={el.id}
                                    align='left'
                                    style={{ ...styleTable.headerCell, ...stickyStyle }}
                                    sortDirection={isCurrentActive ? currentDir : false}
                                >
                                    {el.sortable ?(
                                        <TableSortLabel
                                            active={isCurrentActive}
                                            direction={isCurrentActive ? currentDir : 'asc'}
                                            onClick={() => handleSort(el.id)}
                                            hideSortIcon={false}
                                            sx={{
                                                '& .MuiTableSortLabel-icon': {
                                                    opacity: 1, 
                                                    color: isCurrentActive ? 'inherit' : 'rgba(0, 0, 0, 0.25) !important',
                                                },
                                            }}
                                        >
                                            {el.title || el.id}
                                        </TableSortLabel>
                                    ) : (
                                        el.title || el.id
                                    )}
                                </TableCell>
                            );
                        })}
                        {(ds.descr.details || aditionalAction?.length > 0 ) &&
                            <TableCell style={{ 
                                ...styleTable.cell, 
                                position: 'sticky', 
                                right: 0, 
                                backgroundColor: 'white', 
                                zIndex: 11, 
                                // boxShadow: '-2px 0 5px rgba(0,0,0,0.15)', 
                                width: "40px"
                            }} component='th' scope="row" padding="none" align='left'>
                                <div style={{width: "100%", height: "100%", backgroundColor: 'white'}}></div>
                            </TableCell>
                        }
                    </TableRow>
                </TableHead>
                }
                
                <TableBody>
                    {/* Рендерим showData (в нем уже применены фильтры, сортировка и пагинация) */}
                    {showData.map((el) => {
                        return (
                            <React.Fragment key={`${el.id}Fragment`}>
                                <TableRow 
                                    key={el.id} 
                                    hover={ds.descr?.selectRow || ds.descr?.expanded} 
                                    onClick={() => { 
                                        onClickRow && onClickRow(el); 
                                        ds.descr?.selectRow && setSelectedRowId(el.id); 
                                        ds.descr?.expanded && toggleRow(el.id);
                                    }}
                                    style={{
                                        cursor: ds.descr?.selectRow || ds.descr?.expanded ? "pointer" : 'auto',
                                        pointerEvents: el?.disabledRow ? "none" : "auto",
                                        opacity: el?.disabledRow ? 0.5 : 1,
                                        verticalAlign: 'top',
                                        backgroundColor: (finded || []).includes(el.id)? 'rgba(189, 219, 221, 0.4)': "white"
                                    }}
                                    selected={selectedRowId === el.id || expandedRows.includes(el.id)}
                                >
                                    {ds.descr.showCheckboxes && (
                                        <TableCell component="th" scope="row" align='center'
                                            sx={{ 
                                                width: CHECKBOX_COLUMN_WIDTH,
                                                minWidth: CHECKBOX_COLUMN_WIDTH,
                                                maxWidth: CHECKBOX_COLUMN_WIDTH,
                                                padding: 0,               // убираем внутренние отступы
                                                textAlign: 'center'
                                            }}
                                        >
                                            <Checkbox
                                                color="primary"
                                                checked={selected.includes(el.id)}
                                                onClick={(event) => event.stopPropagation()}
                                                onChange={() => handleClick(el.id)}
                                                disabled={!editable}
                                            />
                                        </TableCell>
                                    )}
                                    
                                    {$fields.map((field, index) => {
                                        // ДОБАВЛЕНО: стили для закрепления ячейки с учетом left и right 
                                        // Задаем плотный цвет фона, чтобы прозрачная строка поиска не наслаивалась некрасиво на текст
                                        const stickyStyle = field.visible ? {
                                            position: 'sticky',
                                            ...(field.visible === 'left' ? { left: 0, boxShadow: '2px 0 5px rgba(0,0,0,0.15)' } : { right: 0, boxShadow: '-2px 0 5px rgba(0,0,0,0.15)' }),
                                            backgroundColor: (finded || []).includes(el.id) ? '#e6f2f3' : 'white',
                                            zIndex: 5,
                                        } : {};

                                        return (
                                            <TableCell 
                                                style={{ 
                                                    ...styleTable.cell,
                                                    width: field.width || 'auto', 
                                                    minWidth: field.width || 'auto',
                                                    ...stickyStyle
                                                }} 
                                                component='th' scope="row" padding="none" align='left' key={el.id + index}
                                            >
                                                <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '6px', paddingLeft: '16px', paddingBottom: '6px' }}>
                                                    {field?.formatter? 
                                                        renderFormatted(Array.isArray(field.id)? field.id.map((ael) => _.get(el, ael)): _.get(el, field.id), field, {row:{id:el.id}}, formatterChangeSelecter, () => {onClickRow && onClickRow(el); ds.descr?.expanded && toggleRow(el.id);}) 
                                                        : Array.isArray(field.id)? field.id.map((ael) => _.get(el, ael)): _.get(el, field.id)
                                                    }
                                                </div>
                                            </TableCell>
                                        );
                                    })}
                                    
                                    {(ds.descr.details || aditionalAction?.length > 0 ) && 
                                        // ДОБАВЛЕНО: принудительное закрепление для ячейки details
                                        <TableCell style={{ 
                                            ...styleTable.cell, 
                                            position: 'sticky', 
                                            right: 0, 
                                            backgroundColor: (finded || []).includes(el.id) ? '#e6f2f3' : 'white', 
                                            zIndex: 10, 
                                            borderLeft: '1px solid',
                                            // boxShadow: '-2px 0 5px rgba(0,0,0,0.15)',
                                            width: ds.descr.additionalOrientation === 'column'? "40px": `${aditionalAction.length * 45}px`
                                        }} component='th' scope="row" padding="none" align='left'>
                                            <div style={{ display: 'flex', flexDirection: ds.descr.additionalOrientation || 'column', alignItems: 'center', marginTop: "5px"}}>
                                                {ds.descr.details && 
                                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: "5px"}}>
                                                        <IconButton onClick={(e) => { e.stopPropagation(); ds.descr.showDetails(el); }}><InfoIcon/></IconButton>
                                                    </div>   
                                                }
                                                {aditionalAction.length > 0 &&
                                                    <div>
                                                        {aditionalAction.map((ael, aindex) => !ael.exp && (!ael.flag  || (ael.flag && _.get(el, ael.flag))) &&(
                                                            <IconButton 
                                                                sx={{marginBottom: "5px"}}
                                                                key={aindex} aria-label={"AA_"+aindex} onClick={(event) => {event.stopPropagation(); ael.action(el)}}>
                                                                {ael.ui()}
                                                            </IconButton>
                                                        ))}
                                                    </div>
                                                }
                                            </div>
                                        </TableCell>
                                    }

                                    {ds.descr.expanded && el.expanded?.length > 0 && 
                                        <TableCell style={{ ...styleTable.cell }} component='th' scope="row" padding="none" align='left'>
                                            <div style={{ display: 'flex', justifyContent: 'flex-start'}}>
                                                {/* <IconButton onClick={(e) => { e.stopPropagation(); toggleRow(el.id); }}>
                                                    {expandedRows.includes(el.id) ? <KeyboardArrowUpIcon sx={{height: "40px", width: "40px"}}/> : <KeyboardArrowDownIcon sx={{height: "40px", width: "40px"}}/>}
                                                </IconButton> */}
                                            </div>
                                        </TableCell>
                                    }
                                    
                                </TableRow>

                                {/* Развёрнутые подстроки */}
                                {ds.descr.expanded && expandedRows.includes(el.id) && el?.expanded?.map((expanded, index) => {
                                    return (
                                        <TableRow key={`${expanded.id || el.id}-${index}-expanded`} style={{ verticalAlign: 'top' }}>
                                            {/* Пустая ячейка для чекбокса (если он есть) – для выравнивания */}
                                            {ds.descr.showCheckboxes && (
                                                <TableCell
                                                    style={{
                                                        width: CHECKBOX_COLUMN_WIDTH,
                                                        minWidth: CHECKBOX_COLUMN_WIDTH,
                                                        maxWidth: CHECKBOX_COLUMN_WIDTH,
                                                        padding: 0
                                                    }}
                                                />
                                            )}

                                            {/* Поля с теми же sticky-стилями, что и в основной строке */}
                                            {$fields.map((field, fIndex) => {
                                                const stickyStyle = field.visible ? {
                                                    position: 'sticky',
                                                    ...(field.visible === 'left' ? { left: 0, boxShadow: '2px 0 5px rgba(0,0,0,0.15)' } : { right: 0, boxShadow: '-2px 0 5px rgba(0,0,0,0.15)' }),
                                                    backgroundColor: 'white',
                                                    zIndex: 5,
                                                } : {};

                                                return (
                                                    <TableCell
                                                        key={fIndex}
                                                        style={{
                                                            ...styleTable.cell,
                                                            width: field.width || 'auto',
                                                            minWidth: field.width || 'auto',
                                                            ...stickyStyle
                                                        }}
                                                        component='th' scope="row" padding="none" align='left'
                                                    >
                                                        <div style={{ padding: '12px 16px' }}>
                                                            {field?.formatter
                                                                ? renderFormatted(
                                                                    Array.isArray(field.id)
                                                                        ? field.id.map((ael) => _.get(expanded, ael))
                                                                        : _.get(expanded, field.id),
                                                                    field,
                                                                    { row: { expId: expanded.id, id: el.id } },
                                                                    formatterChangeSelecter
                                                                )
                                                                : Array.isArray(field.id)
                                                                    ? field.id.map((ael) => _.get(expanded, ael))
                                                                    : _.get(expanded, field.id)
                                                            }
                                                        </div>
                                                    </TableCell>
                                                );
                                            })}

                                            {/* Правая закреплённая колонка (details / aditionalAction) – такая же, как в основной строке */}
                                            {(ds.descr.details || aditionalAction?.length > 0) && (
                                                <TableCell
                                                    style={{
                                                        ...styleTable.cell,
                                                        position: 'sticky',
                                                        right: 0,
                                                        backgroundColor: 'white',
                                                        zIndex: 10,
                                                        borderLeft: '1px solid',
                                                        width: "40px"
                                                    }}
                                                    component='th' scope="row" padding="none" align='left'
                                                >
                                                    <div style={{ display: 'flex', flexDirection: ds.descr.additionalOrientation || 'column', alignItems: 'center', marginTop: "5px" }}>
                                                        {ds.descr.details && (
                                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: "5px" }}>
                                                                <IconButton onClick={(e) => { e.stopPropagation(); ds.descr.showDetails(el); }}><InfoIcon /></IconButton>
                                                            </div>
                                                        )}
                                                        {aditionalAction.length > 0 && (
                                                            <div>
                                                                {aditionalAction.map((ael, aindex) => ael.exp && (!ael.flag  || (ael.flag && _.get(el, ael.flag))) &&(
                                                                    <IconButton
                                                                        sx={{ marginBottom: "5px" }}
                                                                        key={aindex}
                                                                        aria-label={"AA_" + aindex}
                                                                        onClick={(event) => { event.stopPropagation(); ael.action(expanded); }}
                                                                    >
                                                                        {ael.ui()}
                                                                    </IconButton>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                </TableCell>
                                            )}

                                            {/* Пустая ячейка для expanded (если в основной строке она есть) – для сохранения структуры */}
                                            {ds.descr.expanded && el.expanded?.length > 0 && (
                                                <TableCell style={{ ...styleTable.cell }} component='th' scope="row" padding="none" align='left'>
                                                    <div style={{ display: 'flex', justifyContent: 'flex-start' }}></div>
                                                </TableCell>
                                            )}
                                        </TableRow>
                                    );
                                })}
                            </React.Fragment>
                        )
                    })}
                </TableBody>
            </Table>
            
            {!onPageChange && autoPagination > 0 && (
                <Pagination
                    page={currentPage}
                    count={Math.ceil(processedData.length / autoPagination)}
                    onChange={(ev, page) => onAutoPageChange(page)}
                    variant="outlined"
                    color="primary"
                    style={{ marginTop: '16px', display: 'flex', justifyContent: 'left'}}
                />
            )}
            
            {onPageChange && (
                <Pagination
                    count={count}
                    onChange={(ev, page) => onPageChange(page)}
                    variant="outlined"
                    color="primary"
                    style={{ marginTop: '16px', display: 'flex', justifyContent: 'center' }}
                />
            )}
        </div>
    )
}

// PropTypes и дефолтные значения
ReportTable.propTypes = {
    descriptor: PropTypes.object,
    ds: PropTypes.object,
    data: PropTypes.array,
    onSelect: PropTypes.func,
    count: PropTypes.number,
    onPageChange: PropTypes.func,
    onClickRow: PropTypes.func,
    onFormatterChange: PropTypes.func,
    filterSettings: PropTypes.object,
    autoPagination: PropTypes.number,
    inputSelected:PropTypes.arrayOf(PropTypes.any),
    aditionalAction:PropTypes.array,
    editable: PropTypes.bool,
    finded: PropTypes.array,
    customNoDataText: PropTypes.string,
};

ReportTable.defaultProps = {
    descriptor: {},
    ds: {},
    data: [],
    onSelect: () => { },
    count: 0,
    onPageChange: null,
    onFormatterChange: () => { },
    onClickRow: () => { },
    filterSettings: {},
    autoPagination: 0,
    inputSelected: [],
    aditionalAction: [],
    editable: true,
    finded: [],
    customNoDataText: undefined
};